module.exports = __webpack_public_path__ + "img/services-case3-1.32130dbf.png";